import { useState, useEffect } from "react";
import { fetchTypes } from "../dao/types";

export default function useFetchTypes(type) {
  const [typesData, setTypesData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const getTypes = async () => {
      setIsLoading(true);
      try {
        const data = await fetchTypes(type);
        // Filter out items with a blank description, 
        // which are deprecated values that still could be used in documents.
        setTypesData(data.filter((item) => item.description !== ""));
      } catch (error) {
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };
    getTypes();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [typesData, isLoading, error];
}
